const i18n = {
  'salesReturnForm': {
    'name': '銷貨退回單',
    'tab': {
      'pending': '等候中',
      'done': '已完成',
    },
    'table': {
      'title': '銷貨退回單列表',
      'selected': '已選擇 {count} 筆銷貨退回單',
      'header': {
        'sn': '銷貨退回單號',
        'source': '退貨單位',
        'sourceName': '退貨單位',
        'supplier': '原銷貨單位',
        'supplierName': '原銷貨單位',
        'createdBy': '退貨人',
        'date': '退貨日期',
      },
      'detail': {
        'sn': '銷貨退回單號',
        'source': '退貨單位',
        'sourceName': '退貨單位',
        'supplier': '原銷貨單位',
        'supplierName': '原銷貨單位',
        'createdBy': '退貨人',
        'date': '退貨日期',
        'note': '備註',
        'merchandise': '商品',
      },
    },
    'dialog': {
      'title': {
        'add': '新增退貨單',
      }
    },
    'merchandise': {
      'code': '品號',
      'name': '品名',
      'require': '需求量',
      'unitPrice': '單價',
      'amount': '數量',
      'orderUnit': '單位',
      'sku': '單位',
      'price': '金額',
      'lotNumber': '批號',
      'date': '出貨日期',
      'expectedDate': '效期',
      'statusText': '狀態',
      'note': '備註',
      'stock': '即時庫存',
      'delivery': ' 出貨量',
    }
  }
}
export default i18n
